
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'


const imgList = [
'../../static/u4.png',
]

const demoList = imgList.map((one, index) => ({
url: 'javascript:',
img: one
}))

export default {
components: {
Swiper,
XHeader,
Flexbox,
FlexboxItem,
ViewBox
},
methods: {
jump: function (e) {
this.$router.push(e);
}
},
data() {
return {
demo_list: demoList,
images1: [
'../../static/u16.png',
'../../static/u18.png',
'../../static/u20.png'
],
images2: [
'../../static/u16.png',
'../../static/u18.png',
'../../static/u20.png'
],
}

}
}



// WEBPACK FOOTER //
// ./src/views/Index.vue